<template>
  <div class="pc-list" ref="list">
    <RinkingUniversitySearch @search="search" />

    <div class="pc-list-head">
      <!-- <el-checkbox v-model="isSelectAll" @change="selectAll">全选</el-checkbox> -->
      <!-- <el-checkbox v-model="isSelectAll">全选&nbsp;&nbsp;{{ '(已选' + selectCount + '个)' }}</el-checkbox> -->
      <div class="pc-list-head-handle">
        <div class="pc-list-head-btn">
          <button @click="deleteUser">删除</button>
          <span></span>
          <button @click="addUser">添加</button>
          <span></span>
          <button @click="exportUser">导出数据</button>
        </div>
        <p>{{ "共" + dataArgs.total + "条" }}</p>
      </div>
    </div>

    <el-table
      class="pc-list-table"
      :data="universityRink"
      @sort-change="changeSort"
    >
      <el-table-column fixed="left" width="110">
        <template slot="header" >
          <el-checkbox v-model="isSelectAll" @change="selectAll">{{
            "已选" + checked.length + "个"
          }}</el-checkbox>
        </template>
        <template  slot-scope="scope">
          <el-checkbox
            v-model="scope.row.isSelect"
            @change="
              singleCheck(
                scope.$index,
                scope.row.isSelect,
                scope.row.id,
                scope.row
              )
            "
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column fixed label="名称" sortable width="220">
        <template slot-scope="scope">
          <span
            v-show="universityStatus != scope.$index"
            v-if="scope.row.university"
            >{{ scope.row.university.name }}</span
          >

          <el-select
            v-model="scope.row.university.name"
            v-show="universityStatus == scope.$index"
            placeholder="选择学校"
            @change="choiceUniversity"
            clearable
            class="tag"
          >
            <el-option
              v-for="(item, index) in universityList"
              :key="index"
              :label="item.name"
              :value="index"
            ></el-option>
          </el-select>
          <!-- <input :value="scope.row.university.name" v-show="universityStatus==true" /> -->
        </template>
      </el-table-column>
      <el-table-column prop="teaching" label="Education" width="100">
        <template slot-scope="scope">
          <span v-show="universityStatus != scope.$index">{{
            scope.row.teaching
          }}</span>
          <el-input
            v-model="scope.row.teaching"
            v-show="universityStatus == scope.$index"
            placeholder=""
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="research" label="Research" width="100">
        <template slot-scope="scope">
          <span v-show="universityStatus != scope.$index">{{
            scope.row.research
          }}</span>
          <el-input
            v-model="scope.row.research"
            v-show="universityStatus == scope.$index"
            placeholder=""
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="social" label="Influence" width="100">
        <template slot-scope="scope">
          <span v-show="universityStatus != scope.$index">{{
            scope.row.social
          }}</span>
          <el-input
            v-model="scope.row.social"
            v-show="universityStatus == scope.$index"
            placeholder=""
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="overall" label="Overall" width="100">
        <template slot-scope="scope">
          <span v-show="universityStatus != scope.$index">{{
            scope.row.overall
          }}</span>
          <el-input
            v-model="scope.row.overall"
            v-show="universityStatus == scope.$index"
            placeholder=""
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="students" label="Students" width="100">
        <template slot-scope="scope">
          <span v-show="universityStatus != scope.$index">{{
            scope.row.students
          }}</span>
          <el-input
            v-model="scope.row.students"
            v-show="universityStatus == scope.$index"
            placeholder=""
          ></el-input>
        </template>
      </el-table-column>
      <!-- 省略号 -->
      <el-table-column prop="videoNum" label="VideoNum" width="100">
        <template slot-scope="scope">
          <span v-show="universityStatus != scope.$index">{{
            scope.row.videoNum
          }}</span>
          <el-input
            v-model="scope.row.videoNum"
            v-show="universityStatus == scope.$index"
            placeholder=""
          ></el-input>
        </template>
      </el-table-column>

      <el-table-column prop="degreeCoherene" label="DegreeCoherene" width="140">
        <template slot-scope="scope">
          <span v-show="universityStatus != scope.$index">{{
            scope.row.degreeCoherene
          }}</span>
          <el-input
            v-model="scope.row.degreeCoherene"
            v-show="universityStatus == scope.$index"
            placeholder=""
          ></el-input>
        </template>
      </el-table-column>

      <el-table-column prop="facultyNum" label="FacultyNum" width="140">
        <template slot-scope="scope">
          <span v-show="universityStatus != scope.$index">{{
            scope.row.facultyNum
          }}</span>
          <el-input
            v-model="scope.row.facultyNum"
            v-show="universityStatus == scope.$index"
            placeholder=""
          ></el-input>
        </template>
      </el-table-column>

      <el-table-column prop="citations" label="Citations" width="100">
        <template slot-scope="scope">
          <span v-show="universityStatus != scope.$index">{{
            scope.row.citations
          }}</span>
          <el-input
            v-model="scope.row.citations"
            v-show="universityStatus == scope.$index"
            placeholder=""
          ></el-input>
        </template>
      </el-table-column>

      <el-table-column prop="searchNum" label="SearchNum" width="100">
        <template slot-scope="scope">
          <span v-show="universityStatus != scope.$index">{{
            scope.row.searchNum
          }}</span>
          <el-input
            v-model="scope.row.searchNum"
            v-show="universityStatus == scope.$index"
            placeholder=""
          ></el-input>
        </template>
      </el-table-column>

      <el-table-column
        prop="updateTime"
        sortable="custom"
        label="最近修改"
        width="180"
      >
        <template slot-scope="scope">
          <span v-show="universityStatus != scope.$index">{{
            scope.row.updateTime
          }}</span>
          <el-input
            v-model="scope.row.updateTime"
            v-show="universityStatus == scope.$index"
            placeholder=""
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" sortable="custom" width="100">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#91CC75"
            inactive-color="#C7C7C7"
            :class="{
              'switch-is-active': scope.row.status,
              'switch-is-not-active': !scope.row.status
            }"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column width="180">
        <template slot-scope="scope">
          <button
            v-show="universityStatus != scope.$index && rankType == 'update'"
            class="btnViewDetail"
            @click="viewDetail(scope.row, scope.$index)"
          >
            修改
          </button>
          <i
            v-show="universityStatus == scope.$index && rankType == 'add'"
            @click="viewDelete(scope.row, scope.$index)"
            class="el-icon-error"
          ></i>
          <i
            v-show="universityStatus == scope.$index && rankType == 'add'"
            @click="viewAdd(scope.row, scope.$index)"
            class="el-icon-success"
          ></i>
          <!-- <button
            v-show="universityStatus == scope.$index&&rankType=='add'"
            class="btnViewDetail"
            @click="viewAdd(scope.row,scope.$index)"
          >
             新增
          </button> -->
          <button
            v-show="universityStatus == scope.$index && rankType == 'update'"
            class="btnViewDetail"
            @click="finishDetail(scope.row)"
          >
            完成
          </button>
        </template>
      </el-table-column>
    </el-table>
    <ExportTable
      :tableData="selectedItems"
      :exportFeild="exportFeild"
      ref="exportTable"
    />
    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="isDelete"
    />
    <Pagination
      v-if="universityRink.length > 0"
      class="pagination"
      :pagination="dataArgs"
      @goPage="goPage"
      @handleCurrentChange="goPage"
      @goLastPage="goPage"
      @goFirstPage="goPage"
    />
  </div>
</template>



<script>
import Pagination from "../../../template/Pagination";
import { getUniversities } from "./universityList.gql";
import {
  getUniversityRanks,
  addUniversityRank,
  updateUniversityRank,
  deleteUniversitieRanks
} from "./rinkingUniversity.gql";
import RinkingUniversitySearch from "./RinkingUniversitySearch";
import DeleteHint from "../../../template/DeleteHint";
// 导出数据
import ExportTable from "../../../template/exportTable.vue";
export default {
  components: {
    RinkingUniversitySearch,
    Pagination,
    ExportTable,
    DeleteHint
  },
  props: { nowYear: String, tabPosition: Number },
  data() {
    return {
      selectIndex: null,
      isCancelSingle: true,
      isSelectAll: false,
      selectCount: 0,
      dataArgs: {
        take: 10,
        skip: 0,
        order: "-createTime",
        count: null,
        status: -1,
        month: ""
      },
      universityArgs: {
        take: 0,
        skip: 0,
        order: "-englishName",
        count: null,
        status: -1
      },
      // 排行表格数据
      universityRink: [],
      // 学校下拉列表
      universityList: [],
      // 是否被选中
      checked: [],
      // 大学排行页的未修改状态
      universityStatus: -1,
      //判断当前的状态
      rankType: "update",
      // 新增显示修改
      addUpdate: false,
      // 导出数据用的
      selectedItems: [],
      exportFeild: [
        { label: "名称", prop: "university.name" },
        { label: "Education", prop: "teaching" },
        { label: "Research", prop: "research" },
        { label: "Influence", prop: "social" },
        { label: "Overall", prop: "overall" },
        { label: "Students", prop: "students" },
        { label: "VideoNum", prop: "videoNum" },
        { label: "DegreeCoherene", prop: "degreeCoherene" },
        { label: "FacultyNum", prop: "facultyNum" },
        { label: "Citations", prop: "citations" },
        { label: "SearchNum", prop: "searchNum" },
        { label: "最近修改", prop: "updateTime" },
        { label: "状态", prop: "status1" }
      ],
      // 存储新增选中的
      universitiesId: 0,
      // 删除的弹框
      deleteDialogVisible: false
      // chocieSchoolId:0,
    };
  },
  created() {},
  mounted() {
    this.rankType = "update";
    this.getUniversityRanks();
    this.getUniversities();
  },
  methods: {
    // 父组件传递  修改年份
    changeDataArgs(year) {
      this.dataArgs.year = year;
      this.getUniversityRanks();
    },
    // 父组件传递  修改月份
    changeMonthArgs(month) {
      this.dataArgs.month = month.toString();
      this.getUniversityRanks();
    },
    getUniversityRanks() {
      this.$global
        .GraphqlQuery(this, getUniversityRanks, this.dataArgs)
        .then(res => {
          this.checked = [];
          res.data.forEach((item, i, arr) => {
            // 注册时间
            item.createTime = this.$dtime(item.createTime).format("YYYY.MM.DD");
            // 最近登录
            item.updateTime = this.$dtime(item.updateTime).format("YYYY.MM.DD");
            // 勾选
            item.isSelect = false;
            // 状态
            item.status = item.status == 1 ? true : false;
          });
          this.dataArgs.total = res.total;
          this.universityRink = res.data;
        });
    },
    getUniversities() {
      this.dataArgs.take;
      this.$global
        .GraphqlQuery(this, getUniversities, this.universityArgs)
        .then(res => {
          this.universityList = res.data;
        });
    },
    // 点击修改展示input框
    viewDetail(item, index) {
      this.rankType = "update";
      this.universityStatus = index;
    },
    viewDelete(item, index) {
      this.rankType = "update";
      this.universityRink.splice(index, 1);
    },
    viewAdd(item, index) {
      this.rankType = "update";
      this.addUpdate = false;
      item.month = (this.tabPosition + 1).toString();
      item.year = this.nowYear;
      this.universityStatus = -1;
      item.universityId = parseFloat(this.universitiesId);
      item.status = JSON.parse(
        JSON.stringify((item.status == false) == true ? 0 : 1)
      );
      let {
        universityId,
        research,
        teaching,
        social,
        students,
        overall,
        videoNum,
        degreeCoherene,
        facultyNum,
        citations,
        searchNum,
        status,
        month,
        year
      } = item;
      const subEntity = {
        universityId,
        teaching,
        research,
        social,
        students,
        overall,
        videoNum,
        degreeCoherene,
        facultyNum,
        citations,
        searchNum,
        status,
        month,
        year
      };
      this.$global
        .GraphqlMutation(this, addUniversityRank, {
          // Parameters
          data: this.$global.checkNull(subEntity)
        })
        .then(res => {
          this.$global.success(this, "操作成功");

          this.getUniversityRanks();
          this.universityStatus = -1;
        });
    },
    // 点击完成隐藏input框
    finishDetail(row) {
      row.year = this.nowYear;
      row.status = JSON.parse(
        JSON.stringify((row.status == false) == true ? 0 : 1)
      );
      let {
        research,
        teaching,
        social,
        students,
        overall,
                videoNum,
        degreeCoherene,
        facultyNum,
        citations,
        searchNum,
        status,
        month,
        year
      } = row;
      const subEntity = {
        research,
        social,
        teaching,
        students,
        overall,
                videoNum,
        degreeCoherene,
        facultyNum,
        citations,
        searchNum,
        year,
        status,
        month
      };
      this.$global
        .GraphqlMutation(this, updateUniversityRank, {
          // Parameters
          data: this.$global.checkNull(subEntity),
          id: row.id
        })
        .then(res => {
          this.$global.success(this, "操作成功");

          this.getUniversityRanks();
          this.universityStatus = -1;
        });
    },
    search(val) {
      val.status = parseInt(val.status);
      this.dataArgs = {
        total: this.dataArgs.total,
        skip: this.dataArgs.skip,
        take: this.dataArgs.take,
        order: this.dataArgs.order,
        universityId: val.realName,
        year: this.nowYear,
        status: val.status,
        id: val.userId,
        name: val.realName,
        keywords: val.keyword
      };
      this.getUniversityRanks();
    },
    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.selectedItems = [];
        this.universityRink.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
          if (item.status == true) {
            item.status1 = "有效";
          } else {
            item.status1 = "失效";
          }
          this.selectedItems.push(item);
        });
      } else {
        this.universityRink.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
          this.selectedItems = [];
          if (item.status == true) {
            item.status1 = "有效";
          } else {
            item.status1 = "失效";
          }
        });
      }
    },
    // 单选按钮
    singleCheck(index, isSelect, rowID, row) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            this.selectedItems.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (row.status == true) {
          row.status1 = "有效";
        } else {
          row.status1 = "失效";
        }
        this.selectedItems.push(row);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
    },

    choiceUniversity(id) {
      this.universitiesId = this.universityList[id].id;
      // this.universityList[id].universityId = this.universityList[id].id;
    },
    deleteUser() {
      this.deleteDialogVisible = true;
    },

    // 新增用户
    addUser() {
      this.addUpdate = true;
      let a = new Date();
      a = this.$dtime(a).format("YYYY-MM-DD");
      this.universityRink.push({
        name: "11",
        university: { name: "" },
        updateTime: a,
        status:false
      });
      this.universityStatus = this.universityRink.length - 1;
      this.rankType = "add";
    },
    exportUser() {
      this.$refs.exportTable.exports();
    },
    // 排序
    changeSort(val) {
      if (val.order == "ascending") {
        this.dataArgs.order = "+" + val.prop;
      }
      if (val.order == "descending") {
        this.dataArgs.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.dataArgs.order = "-updateTime";
      }
      this.dataArgs.skip = 0;
      this.getUniversityRanks();
    },
    isDelete() {
      let data = { ids: this.checked };
      this.$global
        .GraphqlMutation(this, deleteUniversitieRanks, {
          // Parameters
          data: data
        })
        .then(res => {
          this.getUniversityRanks();
          this.deleteDialogVisible = false;
        });
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    goPage(data) {
      this.dataArgs.skip = (data - 1) * 10;
      this.getUniversityRanks();
      window.scrollTo(0, this.$refs.list.offsetTop + 250);
    }
  }
};
</script>



<style lang="scss" scoped>
.pc-list {
  margin-top: 40px;
  padding: 42px 30px 57px;
  border-radius: 4px;
  box-shadow: $shadowCard;

  .pc-list-head {
    // margin-top: 20px;
    // margin-bottom: 30px;
    margin: 20px 0 30px;
    border-top: 1px solid #c0c0c0;
    padding-top: 30px;
    letter-spacing: 1px;
    font-family: $chinese;
    font-size: 14px;
    color: $mainTitle;
    display: flex;
    justify-content: flex-end;
    .pc-list-head-handle {
      // float: right;
      display: flex;
      align-items: center;
      .pc-list-head-btn {
        display: flex;
        border: 1px solid $schoolTagBorder;
        margin-right: 30px;
        border-radius: 4px;
        button,
        p {
          cursor: pointer;
          font-family: $chinese;
          font-size: 14px;
          color: $mainTitle;
          letter-spacing: 1px;
        }
        button {
          width: 100px;
          background: none;
          outline: none;
          padding: 10px 0px;
          box-sizing: content-box;
          border: none;
        }
        span {
          height: 16px;
          border: 1px solid $schoolTagBorder;
          align-self: center;
        }
        button:hover {
          background: $blueBtn;
          color: white;
        }
        p {
          margin-left: 32px;
        }
      }
    }
  }
  
 /deep/ .el-table__row{
    .el-input{
      .el-input__inner{
        height: 30px;
        // width: 30px;
      }
      .el-select__caret{
        line-height: 30px;
      }
    }
    .el-input--suffix{
      .el-input__inner{
        width: 100%;
      }
    }
  }
  .pc-list-table::-webkit-scrollbar {
    height: 10px;
    background: red;
  }
  .pc-list-table {
    overflow: visible !important;
    .btnViewDetail {
      width: 90px;
      height: 30px;
      border-radius: 4px;
      border: 1px solid $timeBtn;
      outline: none;
      background: none;
      font-family: $chinese;
      font-size: 12px;
      color: $timeBtn;
      cursor: pointer;
    }
    .btnViewDetail:hover {
      background: $blueBtn;
      color: white;
    }
    /deep/ .cell {
      text-align: center !important;
      font-family: $chinese !important;
      font-size: 14px !important;
      color: $mainTitle !important;
      .el-icon-error {
        font-size: 18px;
        margin-right: 20px;
        color: $fork;
      }
      .el-icon-success {
        font-size: 18px;
        color: $blueBtna;
      }
    }

    /deep/ .el-switch__core {
      width: 54px !important;
      height: 20px !important;
      display: flex;
      align-items: center;
    }
    .switch-is-active {
      /deep/ .el-switch__core {
        &::before {
          content: "有效";
          font-size: 8px;
          color: white;
          padding-left: 6px;
        }
      }
    }

    .switch-is-not-active {
      /deep/ .el-switch__core {
        &::before {
          content: "无效";
          font-size: 8px;
          color: white;
          padding-left: 22px;
        }
      }
    }
    /deep/ .el-table__body-wrapper {
      min-height: 600px;
    }
    /deep/ .is-leaf {
      border-top: 1px solid #ebeef5;
      background: $base-color !important;
      font-weight: normal !important;
    }
    /deep/ .el-switch__core {
      width: 54px !important;
      height: 20px !important;
      display: flex;
      align-items: center;
    }
  }

  .pagination {
    margin-top: 40px;
  }
  /deep/ .pc-pagin {
    justify-content: flex-end !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/university/components/RinkingUniversityTable.vue